export enum RouteType {
  ORDER_HISTORY = '/order-history',
  CART = '/cart',
  SUBSCRIPTION = '/subscriptions',
  SUBSCRIPTION_PLAN = '/subscription-plan',
  LIST = '/list',
}
export const errorImagePath = 'images/CheckoutPageError.svg';

export const EnableListApiConfig = {
  [RouteType.ORDER_HISTORY as string]: false,
  [RouteType.SUBSCRIPTION as string]: false,
  [RouteType.SUBSCRIPTION_PLAN as string]: false,
  [RouteType.LIST as string]: false,
};
